<template>
  <v-container class="py-5">
    <v-card class="py-5" elevation="1">
      <v-card-title class="pa-8">
        <v-layout row wrap>
          <v-row>
            <h3 class="pl-4">
              <v-icon class="mr-2" color="primary" size="32">mdi-table-account</v-icon>
              Distribution of Selected Health Professionals
            </h3>
          </v-row>
          <v-spacer></v-spacer>
          <v-row class="pr-4 pt-2" justify="end">
            <v-btn
                class="mr-2"
                color="primary"
                @click="dataExportCSV"
            >
              <v-icon left>mdi-microsoft-excel</v-icon>
              Export Report
            </v-btn>
          </v-row>
        </v-layout>
      </v-card-title>
      <v-divider class="my-2"></v-divider>
      <v-card-text id="healthWorkersGenderDistribution">
        <v-data-table
            v-if="!loading"
            id="healthWorkersProfessionDistributionTable"
            :headers="headers"
            :items="data"
            :items-per-page="5"
            class="transparent elevation-3 my-4"
            disable-pagination
            disable-sort
            hide-default-footer
            hide-default-header
        >
          <template #header="{ }">
            <thead class="v-data-table-header">
            <tr>
              <th v-for="(h,i) in headers" :key="i" :colspan="h.children?h.children.length:1"
                  :rowspan="h.children?1:2" class="text-center parent-header td-border-style">
                {{ h.text }}
              </th>
            </tr>
            <tr>
              <th v-for="(h1,i1) in getSubHeader(headers)" :key="i1"
                  class="text-center child-header td-border-style">
                {{ h1.text }}
              </th>
            </tr>
            </thead>
          </template>
          <template v-if="this.userFacilityId === 'federal-ministry-of-health'" slot="body.append">
            <tr class="pink--text">
              <th>National</th>
              <th v-for="item in headers.slice(1,37)" :key="item.text">{{ sumField(item.value.replace(/-/g, "")) }}</th>
            </tr>
          </template>
          <template slot="body.append">
            <tr class="pink--text">
              <th></th>
              <th></th>
              <th v-for="item in headers.slice(2,37)" :key="item.text">
                {{ ((sumField(item.value) * 100) / sumField('total')).toFixed(2) + ' %' }}
              </th>
            </tr>
          </template>
        </v-data-table>
        <h1 v-else>
          <v-col
              class="h5 text-center"
              cols="12"
          >
            Loading The Report ...
          </v-col>
          <v-row
              align-content="center"
              class="fill-height"
              justify="center"
          >
            <v-col class="my-12" cols="6">
              <v-progress-linear
                  color="primary"
                  height="6"
                  indeterminate
                  rounded
              ></v-progress-linear>
            </v-col>
          </v-row>
        </h1>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import XLSX from "xlsx";

export default {
  methods: {
    getSubHeader(headers) {
      let result = [];
      headers
          .filter((i) => i.children)
          .forEach((v) => {
            result = result.concat(v.children);
          });
      return result;
    },
    sumField(key) {
      let sum = 0;
      if (key.startsWith('category')) {
        let newkey = key.split('.').pop()
        sum = this.data.reduce((a, b) => Number(a) + (Number(b.category[newkey]) || 0), 0)
      } else {
        sum = this.data.reduce((a, b) => Number(a) + (Number(b[key]) || 0), 0)
      }
      return sum
    },
    dataExportCSV() {
      let tbl = document.getElementById("healthWorkersProfessionDistributionTable");
      const wb = XLSX.utils.table_to_book(tbl);
      XLSX.writeFile(wb, "Distribution_of_Selected_Health_Professionals.xlsx");
    },
  },
  data() {
    return {
      loading: false,
      headers: [
        {
          "text": "Region",
          "align": "center",
          "sortable": false,
          "value": "name"
        },
        {
          "text": "Estimated Population",
          "value": "population"
        },
        {
          "text": "Prostethic Orthothic",
          "value": "category.prostethicorthothic"
        },
        {
          "text": "Midwifery",
          "value": "category.midwifery"
        },
        {
          "text": "Health Extension/Family health",
          "value": "category.healthextension"
        },
        {
          "text": "Public Health",
          "value": "category.publichealth"
        },
        {
          "text": "Other MSc Professional Specialist",
          "value": "category.othermScprofessionalspecialist"
        },
        {
          "text": "Paramedics Professionals: Emergency Medical Technician (EMT)",
          "value": "category.paramedicsprofessionalsemergencymedicaltechnician"
        },
        {
          "text": "Emergency and Critical",
          "value": "category.emergencyandcritical"
        },
        {
          "text": "Radiology",
          "value": "category.radiology"
        },
        {
          "text": "Anesthesia",
          "value": "category.anesthesia"
        },
        {
          "text": "Nursing",
          "value": "category.nursing"
        },
        {
          "text": "Opthalmology",
          "value": "category.opthalmology"
        },
        {
          "text": "Psychiatry",
          "value": "category.psychiatry"
        },
        {
          "text": "Other BSc Professionals",
          "value": "category.otherbscprofessionals"
        },
        {
          "text": "Environmental & Occupational Health",
          "value": "category.environmentaloccupationalhealth"
        },
        {
          "text": "Audiometry",
          "value": "category.audiometry"
        },
        {
          "text": "Specialist",
          "value": "category.specialist"
        },
        {
          "text": "Health Assistant",
          "value": "category.heahlthassistant"
        },
        {
          "text": "Temporary Transition Positions",
          "value": "category.temporarytransitionpositions"
        },
        {
          "text": "Other Professionals",
          "value": "category.otherprofessionals"
        },
        {
          "text": "Public Health Professional Specialist",
          "value": "category.publichealthprofessionalspecialist"
        },
        {
          "text": "Radiation Therapist (RTT)",
          "value": "category.radiationtherapist"
        },
        {
          "text": "Sub-Specialist",
          "value": "category.subspecialist"
        },
        {
          "text": "Administrative Staff (Non-Health Profession):From Grade 8 to 12",
          "value": "category.administrativestaff812"
        },
        {
          "text": "Administrative Staff (Non-Health Profession):College Diploma/Vocational COC Certificate/10+3/",
          "value": "category.administrativestaffdiplomacoc"
        },
        {
          "text": "Administrative Staff (Non-Health Profession):Degree/Master/PhD",
          "value": "category.administrativestaffdegreemastersphd"
        },
        {
          "text": "Medical Doctor",
          "value": "category.medicaldoctor"
        },
        {
          "text": "Dental Science",
          "value": "category.dentalscience"
        },
        {
          "text": "Pharmacy",
          "value": "category.pharmacy"
        },
        {
          "text": "Medical Pharmacy",
          "value": "category.medicalpharmacy"
        },
        {
          "text": "Forensic Medicine",
          "value": "category.forensicmedicine"
        },
        {
          "text": " Physiotheraphy",
          "value": "category.physiotheraphy"
        },
        {
          "text": "Biomedical Technology",
          "value": "category.biomedicaltechnology"
        },
        {
          "text": "Medical Laboratory",
          "value": "category.medicallaboratory"
        },
        {
          "text": "Health Information Technology",
          "value": "category.healthinformationtechnology"
        },
        {
          "text": "Total",
          "value": "total"
        },
        {
          "text": " Percentage ",
          "value": "percentage"
        }
      ],
      data: [],
      userFacilityId: this.$store.state.user.facilityId
    };
  },
  async created() {
    this.loading = true
    fetch(`/fhir/Location?&_profile=http://ihris.org/fhir/StructureDefinition/ihris-jurisdiction&type=region&_sort=name`).then((response) =>
        response.json().then(async ({entry}) => {
          let all = ""
          entry.map((x) => {
            if (all !== "") all += " || "
            all += `doc['region.keyword'].value.contains('Location/${x.resource.id}')`
          })
          let totalQuery = {
            "query": {
              "bool": {
                "must": [
                  {
                    "script": {
                      "script": {
                        "source": `if(doc['region.keyword'].size() != 0) {if(${all}){return true}}`,
                        "lang": "painless"
                      }
                    }
                  }
                ],
                "must_not": [],
                "filter": []
              }
            },
            "reportOptions": {},
          }
          const url = `/es/jobposition/_count`
          let response = await fetch(url, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(totalQuery)
          })
          let result = await response.json()
          let totalSum = result.count
          console.log({totalSum})
          let length = entry.length
          entry.map(async x => {
            let res = {}
            let id = x.resource.id
            res.id = id
            res.name = x.resource.name
            res.population = x.resource?.extension?.find(
                (y) =>
                    y.url ===
                    "http://ihris.org/fhir/StructureDefinition/ihris-jurisdiction-population-size"
            )?.valueString
            console.log(res)
            let category = {
              prostethicorthothic: 0,
              midwifery: 0,
              healthextension: 0,
              publichealth: 0,
              othermScprofessionalspecialist: 0,
              paramedicsprofessionalsemergencymedicaltechnician: 0,
              emergencyandcritical: 0,
              radiology: 0,
              anesthesia: 0,
              nursing: 0,
              opthalmology: 0,
              psychiatry: 0,
              otherbscprofessionals: 0,
              environmentaloccupationalhealth: 0,
              audiometry: 0,
              specialist: 0,
              heahlthassistant: 0,
              temporarytransitionpositions: 0,
              otherprofessionals: 0,
              publichealthprofessionalspecialist: 0,
              radiationtherapist: 0,
              subspecialist: 0,
              administrativestaff812: 0,
              administrativestaffdiplomacoc: 0,
              administrativestaffdegreemastersphd: 0,
              medicaldoctor: 0,
              dentalscience: 0,
              pharmacy: 0,
              medicalpharmacy: 0,
              forensicmedicine: 0,
              physiotheraphy: 0,
              biomedicaltechnology: 0,
              medicallaboratory: 0,
              healthinformationtechnology: 0,
            };
            let total = 0;
            let query = {
              "query": {
                "bool": {
                  "must": [
                    {
                      "script": {
                        "script": {
                          "source": `if(doc['region.keyword'].size() != 0) {if(doc['region.keyword'].value.contains('Location/${id}')){return true}}`,
                          "lang": "painless"
                        }
                      }
                    }
                  ],
                  "must_not": [],
                  "filter": []
                }
              },
              "aggs": {
                "professionCategories": {
                  "composite": {
                    "sources": [
                      {
                        "categories": {
                          "terms": {
                            "field": "employeeProfessionCategory.keyword"
                          }
                        }
                      }
                    ],
                    "size": 10000
                  }
                }
              },
              "reportOptions": {},
            }
            const url = `/es/jobposition/_search?filter_path=aggregations`
            let response = await fetch(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify(query)
            })
            let result = await response.json()
            result.aggregations.professionCategories.buckets.map((a) => {
              let key = a.key.categories.replace(/-/g, "");
              let count = a.doc_count;
              total += count
              category[key] = count;
            });
            res.category = category
            res.total = total
            let percentage = isNaN(((total * 100) / totalSum).toFixed(2)) ? "-" : ((total * 100) / totalSum).toFixed(2) + " %";
            res.percentage = percentage
            this.data.push(res)
            if (this.data.length === length) {
              this.loading = false
            }
          })
        }))
  }
}
</script>
<style lang="sass">
#healthWorkersGenderDistribution
  $record-text-size: 16px

  .record-item-value
    font-size: $record-text-size
    border-bottom: thin #0c0c0c

  .record-item-unit
    font-size: $record-text-size

  .record-item-value-border
    border: thin #a1a1a1
    margin-right: 4px

  .record-item-key
    font-weight: bold
    font-size: $record-text-size

  .record-content
    border: thin #a1a1a1

  .v-data-table
    td
      padding: 12px 8px
      font-size: $record-text-size
      border-color: rgba(0, 0, 0, 0.12)
      border-style: solid
      border-left-width: 0px
      border-right-width: thin
      border-top-width: 0px
      border-bottom-width: thin
      color: black

    tr
      &:nth-of-type(even)
        background-color: #ced7e1

    th
      border-color: rgb(112, 109, 109)
      border-style: solid
      border-left-width: 0px
      border-right-width: thin
      border-top-width: 0px
      border-bottom-width: thin
      color: white
      background-color: #0d3552
      letter-spacing: 0.03em
      font-size: 14px


  .v-data-table table
    //border: thin 1px #f1f0f0
    border-radius: 5px

  .v-data-table table thead tr th
    font-weight: bold
    font-size: $record-text-size
    padding: 0px 8px

  .v-data-table table tbody tr td .v-btn
    margin-right: 0px !important

  .v-data-table .v-data-table-header__sort-badge
    font-size: 10px

  .v-data-table.theme--dark
    tr th
      color: #9b2323 !important

  .theme--light
    .v-data-table table thead tr th
      color: black

    .v-data-table table thead tr td
      color: black

</style>
